module.exports = __webpack_public_path__ + "img/note_p.3efb3a3d.svg";